export default __webpack_public_path__ + "static/dustsweeper-8e926ebf97bb0ee2421b4f8488fa767b.jpg";